import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";

//staging
// var config = {
//   apiKey: "AIzaSyCDJKsGlsHzH1u5fpZc4uQwAuVnZgYuxKY",
//   authDomain: "react-slack-clone-be33a.firebaseapp.com",
//   databaseURL: "https://react-slack-clone-be33a.firebaseio.com",
//   projectId: "react-slack-clone-be33a",
//   storageBucket: "react-slack-clone-be33a.appspot.com",
//   messagingSenderId: "873445303766"
// };

//production
var config = {
  apiKey: "AIzaSyCqsr7qh2K0BTDBBfzNcUFcgOvSLRTUA4E",
  authDomain: "ew-communication-9e377.firebaseapp.com",
  databaseURL: "https://ew-communication-9e377.firebaseio.com",
  projectId: "ew-communication-9e377",
  storageBucket: "ew-communication-9e377.appspot.com",
  messagingSenderId: "521349847578"
};

firebase.initializeApp(config);

export default firebase;



// WEBPACK FOOTER //
// ./src/firebase.js